import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { accessActions } from "../../../../redux/slice/access.slice";
import { alertPolicyActions } from "../../../../redux/slice/alertPolicy.slice";
import { authActions } from "../../../../redux/slice/auth.slice";
import { devicePolicyActions } from "../../../../redux/slice/devicePolicy.slice";
import { devicesActions } from "../../../../redux/slice/devices.slice";
import { employeesActions } from "../../../../redux/slice/employees.slice";
import { orgGroupsActions } from "../../../../redux/slice/orgGroups.slice";
import { uiActions } from "../../../../redux/slice/ui.slice";
import PolicyAlerts from "../AccessManagement/Policies/PolicyAlerts";
import ManagementHeader from "../ManagementHeader/ManagementHeader";
import Devices from "./Devices/Devices";
import Employees from "./Employees/Employees";
import { getOrdManagmentResources, getOrgNavItems, orgCardcolors } from "./helper";
import OrgGroups from "./OrgGroups/OrgGroups";
import { checkSinglePermission } from "components/shared/helper";
import { USER_PERMISSIONS } from "../AccessManagement/helper";

const OrgManagement = () => {
    const dispatch = useDispatch();
    const [selectedTab, handleSelectedTab] = useState(0);

    useEffect(() => {
        dispatch(uiActions.actions.setSelectedNav('Asset Management'))
    }, [dispatch]);


    const employees = useSelector(employeesActions.selectors.getEmployees);
    const devices = useSelector(devicesActions.selectors.getDevices);
    const orgGroups = useSelector(orgGroupsActions.selectors.getOrgGroups)
    const alertPolicies = useSelector(alertPolicyActions.selectors.getAlertPolicies);
    const devicePolicies = useSelector(devicePolicyActions.selectors.getDevicePolicy)
    const currentUser = useSelector(authActions.selectors.getCurrentUser);
    const userPermissions = useSelector(accessActions.selectors.getUserPermissions)

    const orgNavItems = getOrgNavItems({
        isGroupsAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ASSET_GROUPS, userPermissions, currentUser?.role),
        isEmployeesAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_EMPLOYEES, userPermissions, currentUser?.role),
        isAlertPolicyAllowed: checkSinglePermission(USER_PERMISSIONS.VIEW_ALERT_POLICY, userPermissions, currentUser?.role),
    })

    const renderContent = (selectedTab) => {
        const tabLabel = orgNavItems[selectedTab]?.label;

        switch (tabLabel) {
            case "Groups":
                return <OrgGroups />;
            case "Employees":
                return <Employees />;
            case "Devices":
                return <Devices />;
            case "Alert Policies":
                return <PolicyAlerts />;
            // case "Device Policies":
            //   return <DevicePolicies />;
            default:
                return <OrgGroups />;
        }
    };


    const resources = useMemo(() => {
        return getOrdManagmentResources({ groups: orgGroups?.length, employees: employees?.length, devices: devices?.length, alertPolicies: alertPolicies?.length, policies: devicePolicies?.length });
    }, [orgGroups?.length, employees?.length, devices?.length, alertPolicies?.length, devicePolicies?.length])



    return (
        <>
            <ManagementHeader
                selectedTab={selectedTab}
                handleSelectedTab={handleSelectedTab}
                resources={resources}
                cardColors={orgCardcolors}
                navItems={orgNavItems}
                title="Assets Management"
            />
            {renderContent(selectedTab)}
        </>
    );
};

export default OrgManagement;
